<template>
    <div class="submenu_holder">

        <ul class="submenu items">
            <li class="item" v-if="getUserType > 1">
            <router-link :to="{ name: 'sectionsDashboardWorkPlan' }">
                <span class="item_text">Analitika</span>
            </router-link>
            </li>

            <li class="item">
            <router-link :to="{ name: 'sectionsListWorkPlan' }">
                <span class="item_text">Vsa področja</span>
            </router-link>
            </li>

            <li class="item">
            <router-link :to="{ name: 'FAQWorkPlan' }">
                Pogosto zastavljena vprašanja
            </router-link>
            </li>

            <!-- Uncomment if needed -->
            <!--
            <li class="item" v-if="getUserType > 1">
            <router-link :to="{ name: 'analytics' }">
                <span class="item_text">Analitika</span>
            </router-link>
            </li>
            -->
        </ul>

        <div v-show="showyear" class="change_year">
            Študijsko leto: 
            <select @change="changeYear(selected_year)" v-model="selected_year">
                <option 
                    v-for="year in getYears" 
                    v-bind:value="year" 
                    v-bind:key="year" 
                    :selected="(year == selected_year ? true : null)"
                >
                    {{ year }}
                </option>
            </select>
        </div>

    </div>
</template>


<script>
	import { mapActions } from 'vuex';
	
	export default {
        name: 'SectionsSubMenuWorkPlan',
        props: {
            showyear: {
                type: Boolean,
                default: true
            }
        },
		data: function() {
			return {
                selected_year: this.$store.getters.year
			}
		},
		computed: {
            getYear(){
				return this.$store.getters.year;
            },
            // Get loged user type
			getUserType(){
				return this.$store.state.user.type;
            },
            // Get all years
			getYears() {
				return this.$store.getters.getYears;
			},
		},
		methods: { 		
            ...mapActions([
				'changeYear',
            ]),
        },
		created(){
            
		}
	}
</script>


<style lang="scss" scoped>
</style>
